// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../reason/next/Next.bs.js");
let React = require("react");
let Loader = require("../uikit/reason/atoms/Loader/Loader.bs.js");
let V4 = require("uuid/v4");
let UserSession = require("../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../reason/systemMessages/SystemMessages.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function UnauthenticatedComponentRelay(props) {
  let match = SystemMessages.useSystemMessages();
  let addMessage = match.addMessage;
  let initState = UserSession.useInitState();
  let router = Next.useRouter();
  let next = Stdlib_Option.flatMap(Next.Router.query(router)["next"], url => {
    if (url.startsWith("/")) {
      return url;
    }
  });
  React.useEffect(() => {
    let exit = 0;
    switch (initState) {
      case "Agent" :
      case "Client" :
        exit = 1;
        break;
    }
    if (exit === 1) {
      Next.Router.push(Stdlib_Option.getOr(next, "/"), undefined, undefined, router);
      if (next !== undefined) {
        
      } else {
        addMessage(SystemMessages.Message.make(V4(), "info", "You need to be logged out to view this page", 5000, undefined, undefined));
      }
    }
  }, [initState]);
  switch (initState) {
    case "Loading" :
      return JsxRuntime.jsx(Loader.make, {});
    case "Unauthenticated" :
      return props.renderWrappedComponent();
    default:
      return null;
  }
}

let make = UnauthenticatedComponentRelay;

exports.make = make;
/* Next Not a pure module */
